// Auth pages use the registry-project look (see src/pages/registry-project/dashboard/components/Panel.js):
// flat grey page, white panel with a thin #ECECF3 border, flat borderless fields, one purple action.
export const a = {
  bg: "#F7F7FB",
  border: "#ECECF3",
  ink: "#23264D",
  text: "#6B6B80",
  muted: "#8A8AA0",
  accent: "#8491F7",
  accentHover: "#6B78E8",
  accentText: "#4B55C9",
  tint: "rgba(132, 145, 247, 0.12)",
  field: "#F6F6FB",
  fieldHover: "#ECECF3",
  error: "#DC2626",
};

// Same surface as the registry pages' panels
export const panelSx = {
  bgcolor: "#fff",
  border: `1px solid ${a.border}`,
  borderRadius: "18px",
  boxShadow: "0 1px 2px rgba(35, 38, 77, 0.04)",
};

// Flat, borderless filled fields: #FAFAFD, #ECECF3 on hover, a soft purple tint on focus, a soft red tint on error.
// Helper text keeps a reserved line so validation never makes the form jump.
export const fieldSx = {
  "& .MuiFilledInput-root": {
    borderRadius: "12px",
    backgroundColor: a.field,
    overflow: "hidden",
    transition: "background-color .2s ease, box-shadow .2s ease",
    "&:before, &:after": {display: "none"},
    "&:hover": {backgroundColor: a.fieldHover},
    "&.Mui-focused": {
      backgroundColor: "rgba(132, 145, 247, 0.08)",
      boxShadow: "0 0 0 3px rgba(132, 145, 247, 0.18)",
    },
    "&.Mui-disabled": {backgroundColor: a.field, opacity: 0.7},
    "&.Mui-error": {backgroundColor: "rgba(220, 38, 38, 0.05)"},
  },
  "& .MuiInputBase-input": {color: a.ink, fontSize: 14.5},
  "& .MuiInputLabel-root": {color: a.muted, fontSize: 14},
  // required fields carry a small asterisk in the accent colour; optional fields have no marker
  "& .MuiFormLabel-asterisk": {color: a.accent, "&.Mui-error": {color: a.error}},
  "& .MuiInputLabel-root.Mui-focused": {color: a.accentText},
  "& .MuiInputLabel-root.Mui-error": {color: a.error},
  "& .MuiFormHelperText-root": {minHeight: 18, m: "4px 6px 0", fontSize: 12.5, lineHeight: 1.4},
};

// The one emphasized action of a page (Sign in, Create account, ...)
export const primaryButtonSx = {
  height: 44,
  borderRadius: "12px",
  textTransform: "none",
  fontSize: 14.5,
  fontWeight: 600,
  color: "#fff",
  bgcolor: a.accent,
  boxShadow: "none",
  "&:hover": {bgcolor: a.accentHover, boxShadow: "none"},
  "&.Mui-disabled": {color: "#fff", bgcolor: "rgba(132, 145, 247, 0.4)"},
};

// Everything else: flat neutral
export const secondaryButtonSx = {
  height: 44,
  borderRadius: "12px",
  textTransform: "none",
  fontSize: 14,
  fontWeight: 500,
  color: "#374151",
  bgcolor: a.field,
  "&:hover": {bgcolor: a.fieldHover},
};

// Small text link (Forgot password?, Back, ...)
export const linkSx = {
  color: a.accentText,
  fontSize: 13.5,
  fontWeight: 600,
  textDecoration: "none",
  "&:hover": {textDecoration: "underline"},
};

// Soft notice box (info / success)
export const noticeSx = {
  borderRadius: "12px",
  bgcolor: a.tint,
  color: a.ink,
  fontSize: 13.5,
  lineHeight: 1.5,
  px: 2,
  py: 1.5,
};
